import { Outlet } from '@tanstack/react-router'
import { ThemeContext, useTheme } from './hooks/useTheme'

// This is the main entry point for the application.
// It renders the Outlet component, which is the placeholder for the nested routes.
// Will place here the providers and main configuration for the app in the future.

function App() {
  const theme = useTheme()
  return (
    <ThemeContext.Provider value={theme}>
      <Outlet />
    </ThemeContext.Provider>
  )
}

export default App
